export default {
  lastFiveNotifications(state) {
    const clone = state.notifications.slice(0).reverse();
    return clone.slice(0, 5);
  },
  authLogo(state) {
    const whiteLogo = state.logoWhite || state.logo;

    return state.isMobile ? whiteLogo : state.logo;
  },
  currentSlide(state) {
    return (slideName) => {
      const slide = state.carousel.find(({ name }) => name === slideName);
      const [firstSlide] = state.carousel;

      return slide || firstSlide;
    };
  },
};
